const PrestationAction = [
    {
        code: 'COP',
        text: 'Copropriété',
        Act: [
            {
                code: 'REGCOP',
                text: 'Règlement copropriété',
            },
            {
                code: 'CARNET',
                text: "Carnet d'entretien",
            },
            {
                code: 'DIVERS',
                text: 'Divers',
            },
            {
                code: 'NEWS',
                text: 'News',
            },
            {
                code: 'REPRIS',
                text: 'Reprise',
            },
            {
                code: 'PHOTO',
                text: 'Photos',
            },
            {
                code: 'NOTE',
                text: 'Notes',
            },
            {
                code: 'APPEL',
                text: 'Appels',
            },
            {
                code: 'MUT',
                text: 'Mutation',
            },
            {
                code: 'MUTCE',
                text: 'Mutation C.E.',
            },
        ],
    },
    {
        code: 'AG',
        text: 'Assemblées générales',
        Act: [
            {
                code: 'OJ',
                text: 'Ordres du jour',
            },
            {
                code: 'PV',
                text: 'Procès-verbaux',
            },
            {
                code: 'DIVERS',
                text: 'Divers',
            },
            {
                code: 'PREPA',
                text: 'Préparation',
            },
            {
                code: 'CONTRO',
                text: 'Contrôle CS',
            },
            {
                code: 'ARCCPT',
                text: 'Archives comptabilité',
            },
            {
                code: 'DEVIS',
                text: 'Devis',
            },
            {
                code: 'PHOTO',
                text: 'Photos',
            },
        ],
    },
    {
        code: 'CS',
        text: 'Réunion CS',
        Act: [
            {
                code: 'OJ',
                text: 'Ordres du jour',
            },
            {
                code: 'PV',
                text: 'Procès-verbaux',
            },
            {
                code: 'DEVIS',
                text: 'Devis',
            },
            {
                code: 'DIVERS',
                text: 'Divers',
            },
        ],
    },
    {
        code: 'PRO',
        text: 'Propriétaires',
        Act: [
            {
                code: 'DEM',
                text: 'Courriers pro reçus',
            },
            {
                code: 'REP',
                text: 'Réponses propriétaires',
            },
            {
                code: 'MES',
                text: 'Messages propriétaires',
            },
            {
                code: 'DEMADR',
                text: "Changement d'adresse",
            },
            {
                code: 'PROREG',
                text: 'Règlement pro',
            },
            {
                code: 'MUT',
                text: 'Mutation',
            },
            {
                code: 'ODS',
                text: 'Opérations diverses',
            },
            {
                code: 'PHOTO',
                text: 'Photos',
            },
            {
                code: 'MUTED',
                text: 'État-daté',
            },
        ],
    },
    {
        code: 'FOU',
        text: 'Fournisseurs',
        Act: [
            {
                code: 'DEM',
                text: 'Courriers reçus',
            },
            {
                code: 'CONTRA',
                text: 'Contrats fournisseurs',
            },
            {
                code: 'DEVIS',
                text: 'Devis',
            },
            {
                code: 'DEMINT',
                text: 'Dégradations/Interventions',
            },
            {
                code: 'DEMDEV',
                text: 'Demande de devis',
            },
            {
                code: 'DEMTRA',
                text: 'Demande de travaux',
            },
            {
                code: 'FAC',
                text: 'Facture',
            },
            {
                code: 'FACREG',
                text: 'Règlement facture',
            },
            {
                code: 'ODS',
                text: 'Opérations diverses',
            },
            {
                code: 'PHOTO',
                text: 'Photos',
            },
        ],
    },
    {
        code: 'BNQ',
        text: 'Banques',
        Act: [
            {
                code: 'RELEVE',
                text: 'Relevé de banque',
            },
            {
                code: 'RAPPRO',
                text: 'Rapprochement bancaire',
            },
            {
                code: 'IBAN',
                text: 'IBAN',
            },
        ],
    },
    {
        code: 'EDILOG',
        text: 'Editions comptables',
        Act: [
            {
                code: 'BALPRO',
                text: 'Balance propriétaires',
            },
            {
                code: 'BALCPT',
                text: 'Balance des comptes',
            },
            {
                code: 'BILCPT',
                text: 'Bilan de la copropriété',
            },
            {
                code: 'DCPT',
                text: 'Décomptes',
            },
            {
                code: 'ETADEP',
                text: 'Etat dépenses',
            },
            {
                code: 'ETADET',
                text: 'Etat dépenses détaillées',
            },
            {
                code: 'GLPRO',
                text: 'Grand livre propriétaires',
            },
            {
                code: 'GLCPT',
                text: 'Grand livre des comptes',
            },
            {
                code: 'LSTCOP',
                text: 'Liste des copropriétés',
            },
            {
                code: 'LSTPRO',
                text: 'Liste des propriétaires',
            },
            {
                code: 'LSTCPT',
                text: 'Liste des comptes',
            },
            {
                code: 'LSTNAT',
                text: 'Liste des natures',
            },
            {
                code: 'LSTLOT',
                text: 'Liste des lots',
            },
            {
                code: 'EXTPRO',
                text: 'Extrait propriétaires',
            },
            {
                code: 'APPEL',
                text: 'Appels',
            },
            {
                code: 'PHOTO',
                text: 'Photos',
            },
        ],
    },
    {
        code: 'REPCOM',
        text: 'Reprise comptable',
        Act: [
            {
                code: 'REGCOP',
                text: 'Règlement copropriété',
            },
            {
                code: 'FEUPRE',
                text: 'Feuille de présence',
            },
            {
                code: 'LSTPRO',
                text: 'Liste des propriétaires',
            },
            {
                code: 'PV',
                text: 'Procès-verbaux',
            },
            {
                code: 'GLCPT',
                text: 'Grand livre des comptes',
            },
            {
                code: 'BALCPT',
                text: 'Balance des comptes',
            },
            {
                code: 'ETADET',
                text: 'Etat dépenses détaillées',
            },
            {
                code: 'BUDGET',
                text: 'Budgets',
            },
            {
                code: 'BNQREL',
                text: 'Relevé de banque',
            },
            {
                code: 'DECPRO',
                text: 'Décomptes des propriétaires',
            },
            {
                code: 'DIVERS',
                text: 'Divers',
            },
            {
                code: 'VALIDE',
                text: 'Validations',
            },
        ],
    },
    {
        code: 'KDNOMI',
        text: 'Courriers',
        Act: [
            {
                code: 'PV',
                text: 'Procès-verbaux',
            },
            {
                code: 'OJ',
                text: 'Ordres du jour',
            },
            {
                code: 'APPEL',
                text: 'Appels',
            },
            {
                code: 'NOTIF',
                text: 'Notifications',
            },
            {
                code: 'RAPPEL',
                text: 'Relances',
            },
            {
                code: 'RAP1',
                text: 'Relances',
            },
            {
                code: 'RAP2',
                text: 'Relances',
            },
            {
                code: 'RAP3',
                text: 'Relances',
            },
        ],
    },
    {
        code: 'VISITE',
        text: 'Visites',
        Act: [
            {
                code: 'RAPPOR',
                text: 'Rapports',
            },
        ],
    },
];

export default PrestationAction;



// WEBPACK FOOTER //
// ./src/App_Data/PrestationAction.js